import { get } from "../client";
import { MANUFACTURERS } from "../routes";

export default {
  get: async (vehicle) => await get(MANUFACTURERS(vehicle)),
};
